"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorQuerySourceDereferenceLink = void 0;
const core_1 = require("@comunica/core");
/**
 * A comunica actor for query-source-dereference-link events.
 *
 * Actor types:
 * * Input:  IActionQuerySourceDereferenceLink:      The URL of a source to resolve.
 * * Test:   <none>
 * * Output: IActorQuerySourceDereferenceLinkOutput: A query source and metadata.
 *
 * @see IActionQuerySourceDereferenceLink
 * @see IActorQuerySourceDereferenceLinkOutput
 */
class ActorQuerySourceDereferenceLink extends core_1.Actor {
    /* eslint-disable max-len */
    /**
     * @param args -
     *   \ @defaultNested {<default_bus> a <cc:components/Bus.jsonld#Bus>} bus
     *   \ @defaultNested {Query source dereference link failed: none of the configured actors were able to resolve ${action.link.url}} busFailMessage
     */
    /* eslint-enable max-len */
    constructor(args) {
        super(args);
    }
}
exports.ActorQuerySourceDereferenceLink = ActorQuerySourceDereferenceLink;
//# sourceMappingURL=ActorQuerySourceDereferenceLink.js.map